import { render, staticRenderFns } from "./YesIcon.vue?vue&type=template&id=492af266&scoped=true"
import script from "./YesIcon.vue?vue&type=script&lang=ts"
export * from "./YesIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492af266",
  null
  
)

export default component.exports